// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".remove-liquidity-percentage{border:1px solid rgba(0,0,0,0)!important;border-radius:8px!important;-webkit-transition:border-color .3s;-o-transition:border-color .3s;transition:border-color .3s}.remove-liquidity-percentage:hover{border:1px solid var(--border-2-color)!important}.percentage{font-weight:700}.slider-buy{padding:0 18px}.slider-buy .el-slider__marks-text{font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
